import { validateConfig, ErrorCode } from '../../../common/validation/config';

const checkConfigAndPromptIfError = (config, ignoreErrors = {}) => {
  const error = validateConfig(config, 2, ignoreErrors);

  if (error) {
    switch(error.code) {
      case ErrorCode.NOT_SAVED:
        alert('Utskicket måste vara sparad');
        return false;
      case ErrorCode.IS_SAVING:
        alert('Vänta till utskicket har sparats');
        return false;
      case ErrorCode.INVALID_SEND_DATE:
        alert('Utskicket har ett felaktigt datum');
        return false;
      case ErrorCode.INVALID_TAGS:
        alert('Utskicket saknar korrekta märkningar för någon annons');
        return false;
      case ErrorCode.INVALID_CONSTRAINTS:
        alert('Utskicket saknar någon annons att falla tillbaka på');
        return false;
      case ErrorCode.EMPTY_IMAGE_VALUE:
        alert('Utskicket saknar bild för någon annons');
        return false;
      case ErrorCode.EMPTY_LINK_VALUE:
        alert('Utskicket saknar länk för någon annons');
        return false;
      case ErrorCode.EMPTY_HEADER_VALUE:
        alert('Utskicket saknar rubrik för någon annons');
        return false;
      case ErrorCode.EMPTY_BODY_VALUE:
        alert('Utskicket saknar brödtext för någon annons');
        return false;
      case ErrorCode.EMPTY_BUTTON_VALUE:
        alert('Utskicket saknar knapptext för någon annons');
        return false;
      case ErrorCode.INVALID_SLOT:
        alert('Utskicket har annons med felaktig position');
        return false;
      default:
        alert(error.message);
        return false;
    }
  }

  return true;
};

export { checkConfigAndPromptIfError };



// WEBPACK FOOTER //
// ./client/src/utils/validate-config.js